module.exports = __webpack_public_path__ + "img/testmesure1.c601ad41.jpg";